var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChangeCircleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2178 2C6.69777 2 2.21777 6.48 2.21777 12C2.21777 17.52 6.69777 22 12.2178 22C17.7378 22 22.2178 17.52 22.2178 12C22.2178 6.48 17.7378 2 12.2178 2ZM13.1278 18.15C12.8178 18.46 12.2778 18.24 12.2778 17.8V17C12.2578 17 12.2378 17 12.2178 17C10.9378 17 9.65777 16.51 8.67777 15.54C7.24777 14.11 6.86777 12.02 7.53777 10.24C7.72777 9.73 8.39777 9.6 8.77777 9.99C8.99777 10.21 9.04777 10.53 8.94777 10.81C8.48777 12.05 8.74777 13.49 9.74777 14.49C10.4478 15.19 11.3678 15.52 12.2878 15.5V14.56C12.2878 14.11 12.8278 13.89 13.1378 14.21L14.7578 15.83C14.9578 16.03 14.9578 16.34 14.7578 16.54L13.1278 18.15ZM15.6578 14.02C15.4378 13.8 15.3878 13.48 15.4878 13.2C15.9478 11.96 15.6878 10.52 14.6878 9.52C13.9878 8.82 13.0678 8.48 12.1578 8.5V9.44C12.1578 9.89 11.6178 10.11 11.3078 9.79L9.67777 8.18C9.47777 7.98 9.47777 7.67 9.67777 7.47L11.2978 5.85C11.6078 5.54 12.1478 5.76 12.1478 6.2V7.01C13.4478 6.99 14.7578 7.46 15.7478 8.46C17.1778 9.89 17.5578 11.98 16.8878 13.76C16.6978 14.28 16.0378 14.41 15.6578 14.02Z",
    fill: "#41414B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeCircleIcon);
export default __webpack_public_path__ + "static/media/change_circle_icon.c16c5383.svg";
export { ForwardRef as ReactComponent };